import React from 'react';
import { ReactComponent as FacebookIcon } from './facebook.svg';
import { ReactComponent as InstagramIcon } from './instagram.svg';
import { ReactComponent as TwitterIcon } from './twitter.svg';
import { ReactComponent as MessageIcon } from './message.svg';
import { ReactComponent as HamburgerMenuIcon } from './hamburger_menu.svg';
import { ReactComponent as CloseMenuIcon } from './close_menu.svg';

export default { FacebookIcon, InstagramIcon, TwitterIcon, MessageIcon, HamburgerMenuIcon, CloseMenuIcon };